// extracted by mini-css-extract-plugin
module.exports = {"footer":"Steps_footer__1QZpa","hideSteps":"Steps_hideSteps__31Ct0"};